import BaseService from './BaseService';

class Auth extends BaseService {
    current() {
        return this.get('/auth/user');
    }

    signin(email, company_id, campaign_id, subject_id, redirect) {
        return this.post('/auth/email/signin', {
            email,
            company_id,
            campaign_id,
            subject_id,
            redirect,
        });
    }

    emailsignin(token) {
        return this.post(`/auth/email/signin/${token}`);
    }

    directSignin(token) {
        return this.post(`/auth/direct/signin/${token}`);
    }

    signOutAudit(companyId, scope = 'my') {
        return this.put(`/auth/log/signout/${companyId}`, { scope });
    }

    switchCompanyAudit(oldCompanyId, newCompanyId, scope = 'my') {
        return this.put(`/auth/log/switch`, {
            newCompanyId,
            oldCompanyId,
            scope,
        });
    }

    finishSignIn(token, companyId) {
        return this.put(`/auth/log/signin/${token}`, { companyId });
    }

    checkEmail(email) {
        return this.post('/auth/checkEmail', { email });
    }
}

export default Auth;
